module.exports = __webpack_public_path__ + "3-72.gif?fdda313e6e0bb6df60829c9633064868";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-72.gif
// module id = 154
// module chunks = 0